import config from 'config';
import { init, logEvent, setUserId } from '@amplitude/analytics-browser';
import { BaseEvent, BrowserOptions, EventOptions } from '@amplitude/analytics-browser/lib/esm/types';
import { AmplitudeEventName } from 'shared/types/amplitudeEvent';

export const initAmplitude = (options?: BrowserOptions) => {
  init(config.amplitudeApiKey, {
    ...options,
    defaultTracking: {
      pageViews: false,
    },
  });
};

export const logAmplitudeEvent = (
  eventName: AmplitudeEventName | BaseEvent,
  eventProperties?: EventOptions | Record<string, any>
) => {
  logEvent(eventName, eventProperties);
};

export const setAmplitudeUserId = (userId: string) => {
  setUserId(userId);
};
